import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Box, Button, HStack, Stack } from "@chakra-ui/react";
import moment from "moment";
import { BiReset } from "react-icons/bi";

import Loader from "../../../../components/Loader";
import OrderService from "../../../../services/createOrderService";
import GridV2 from "../../../../utils/agTablesV2";

const PayinSettlement = () => {
  const [refreshGrid, setRefreshGrid] = useState(false);
  const orgId = useSelector((state) => state?.login?.orgDetails?.orgId);
  const isLoading = useSelector((state) => state?.order?.loading);
  const USformatter = new Intl.NumberFormat("en-US");
  const orgIdRef = useRef(orgId);

  const getSettlementData = useCallback(async (filters) => {
    filters.orgId = orgIdRef.current;
    filters["type"] = "payin";
    const responseData = await OrderService.getSettlementData({ filters });
    return responseData;
  }, []);

  const handleReset = () => {
    setRefreshGrid(!refreshGrid);
  };

  const columnsAgTable = [
    {
      headerName: "Fiat Currency",
      field: "currency",
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      customerVisibility: true,
      width: "250",
    },
    {
      headerName: "Total collections amount",
      field: "payin.totalAmount",
      cellDataType: "number",
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      aggFunc: "sum",
      customerVisibility: true,
      width: "250",
      cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    },
    {
      headerName: "Total payout amount",
      field: "payout.totalAmount",
      cellDataType: "number",
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      aggFunc: "sum",
      customerVisibility: true,
      width: "250",
      cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    },
    // {
    //     headerName: "Total payout fees",
    //     field: "payoutFees",
    //     cellDataType: 'number',
    //     getQuickFilterText: params => {
    //         return params.value.name;
    //     },
    //     aggFunc: 'sum',
    //     customerVisibility: true,
    //     width: '250',
    //     cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    // },
    // {
    //   headerName: "Total settled amount",
    //   field: "settlement.totalAmount",
    //   cellDataType: "number",
    //   getQuickFilterText: (params) => {
    //     return params.value.name;
    //   },
    //   aggFunc: "sum",
    //   customerVisibility: true,
    //   width: "250",
    //   cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    // },
    {
      headerName: "Total unsettled amount",
      field: "balance.collectionsBalance",
      cellDataType: "number",
      aggFunc: "sum",
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      customerVisibility: true,
      width: "250",
      cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    },
    {
      headerName: "Available Prefunding amount",
      field: "balance.availableBalance",
      cellDataType: "number",
      aggFunc: "sum",
      getQuickFilterText: (params) => {
        return params.value.name;
      },
      customerVisibility: true,
      width: "250",
      cellRenderer: ({ value }) => <p>{value ? USformatter.format(value) : "0"}</p>,
    },
  ];

  useEffect(() => {
    orgIdRef.current = orgId;
  }, [orgId]);

  return (
    <Stack direction={"column"} justifyContent={"space-between"} flexGrow={1} p={5}>
      {!isLoading ? (
        <Box>
          <HStack pb={5} justifyContent={"flex-end"}>
            <Button
              leftIcon={<BiReset style={{ fontSize: "20px" }} />}
              color={"#525C76"}
              variant={"outline"}
              borderColor={"#d2d2d2"}
              _hover={{ bg: "#ffffff" }}
              onClick={handleReset}
            >
              Reset
            </Button>
          </HStack>
          <GridV2 columns={columnsAgTable} key={refreshGrid.toString()} getOrderData={getSettlementData} dataFetchKey={orgId} />
        </Box>
      ) : (
        <Loader />
      )}
    </Stack>
  );
};

export default PayinSettlement;
